import React from "react";

const AnimatedCircularProgressBar = ({ progress }) => {
  const radius = 40;
  const circumference = 2 * Math.PI * radius;
  const offset = circumference - (progress / 100) * circumference;

  return (
    <svg width="100" height="100" className="rotate-[-90deg]">
      <circle
        stroke="#e5e7eb"
        fill="transparent"
        strokeWidth="8"
        r={radius}
        cx="50"
        cy="50"
      />
      <circle
        stroke="#3b82f6"
        fill="transparent"
        strokeWidth="8"
        r={radius}
        cx="50"
        cy="50"
        strokeDasharray={circumference}
        strokeDashoffset={offset}
        style={{ transition: "stroke-dashoffset 0.3s" }}
      />
      <text
        x="50%"
        y="55%"
        textAnchor="middle"
        fill="#111827"
        fontSize="16px"
        className="rotate-[90deg]"
      >
        {progress}%
      </text>
    </svg>
  );
};

export default AnimatedCircularProgressBar;
